import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { catAndDogTypeId } from 'util/constants';

const initialState = {
  servicedAnimals: [],
  firstName: '',
  lastName: '',
  phone: '',
  countryCodeId: { id: 232, value: 1 },
  email: '',
  services: [{ uuid: uuidv4(), durationMinutes: { value: '60 min', id: 60 } }],
  isAddAllSelected: false,
  uuid: null,
  links: null,
  role: {},
};
const groomerForm = createSlice({
  name: 'groomerForm',
  initialState,
  reducers: {
    initializeForm(state, { payload }) {
      const { user, animal, services, role } = payload;
      const { firstName, lastName, email, phone, uuid, links } = user;

      return {
        servicedAnimals:
          animal.type.length > 1
            ? [{ id: catAndDogTypeId, value: 'Both (Dogs, Cats)' }]
            : animal.type,
        firstName,
        lastName,
        phone: phone?.number,
        countryCodeId: phone?.country?.code,
        email,
        links,
        services: services
          ? services.map((el) => ({
              ...el,
              durationMinutes: {
                value: `${el.durationMinutes} min`,
                id: el.durationMinutes,
              },
            }))
          : [{ uuid: uuidv4(), durationMinutes: { value: '60 min', id: 60 } }],
        uuid,
        role,
      };
    },
    editForm(state, { payload }) {
      const { key, value } = payload;
      state[key] = value;
    },
    addService(state) {
      state.services = [
        ...state.services,
        { uuid: uuidv4(), durationMinutes: { value: '60 min', id: 60 } },
      ];
    },
    editService(state, { payload }) {
      const { index, value, key } = payload;
      state.services[index][key] = value;
    },
    setAllServices(state, { payload }) {
      state.services = payload;
    },
    setAddAllState(state, { payload }) {
      state.isAddAllSelected = payload;
    },
    clearForm() {
      return initialState;
    },
  },
});

const { actions, reducer } = groomerForm;

export const {
  editForm,
  clearForm,
  editService,
  addService,
  setAllServices,
  initializeForm,
  setAddAllState,
} = actions;

export default reducer;
